angular.module('tf.controllers')
    .controller('SharePopupController', ['$scope','$rootScope','ShareService','$uibModalInstance','item','NotificationService', 'FarmService','Session',
        function ($scope, $rootScope, ShareService,$uibModalInstance, item, NotificationService, FarmService, Session) {

            $scope.shareEmails = {
                emails      : [],
                available   : [],
                users       : [],
                groups      : []
            };

            setTimeout(function(){$('.modal input').first().focus();},1);

            $scope.canShare = false;
            $scope.canSchedule = false;
            $scope.name = item.name;
            $scope.shareString = '';
            $scope.sharedUsers = [];
            $scope.expandMembers = false;

            function whoHasAccess(item){
                ShareService.whoHasAccess(item).then(function(data){
                    var users = data.users;
                    var groups = data.groups;
                    $scope.sharedUsers = _.without(users,_.findWhere(users, {id: Session.user.id}));
                    $scope.sharedGroups = groups;
                    $scope.shareString = createString($scope.sharedUsers, groups);

                });
            }

            whoHasAccess(item);



            function createString(users, groups){

                if(users.length === 0 && groups.length === 0){
                    return '';
                }
                if(users.length > 0 ){
                    if(groups.length === 0){
                        //Users only
                        return createUsersString(users);
                    } else {
                        return createGroupsAndUsersString(groups, users);
                    }
                } else {
                    //Groups only
                    return createGroupsString(groups);
                }
            }

            function createUsersAddendumString(users){
                switch (users.length){
                    case 0:
                        return '';
                    case 1:
                        return 'and one other member';
                    case 2:
                        return 'and two other members';
                    default:
                        return 'and ' + users.length + 'other members';
                }
            }

            function createGroupsAndUsersString(groups, users){
                switch (groups.length){
                    case 0:
                        return '';
                    case 1:
                        return 'Shared with ' + groups[0].name + " (group) " + createUsersAddendumString(users);
                    case 2:
                        return 'Shared with ' + groups[0].name + ', ' + groups[1].name + ' (groups) ' + createUsersAddendumString(users);
                    case 3:
                        return 'Shared with ' + _.pluck(groups.slice(0,2),'name').join(', ') + ", one other group " + createUsersAddendumString(users);
                    default:
                        return 'Shared with ' + _.pluck(groups.slice(0,2),'name').join(', ') + ', ' + (groups.length - 2) + ' other groups ' + createUsersAddendumString(users);
                }
            }

            function createUsersString(users){
                switch (users.length){
                    case 0:
                        return '';
                    case 1:
                        return 'Shared with ' + users[0].full_name;
                    case 2:
                        return 'Shared with ' + users[0].full_name + ' and ' + users[1].full_name;
                    case 3:
                        return 'Shared with ' + _.pluck(users.slice(0,2),'full_name').join(', ') + " and one other";
                    default:
                        return 'Shared with ' + _.pluck(users.slice(0,2),'full_name').join(', ') + ' and ' + (users.length - 2) + ' others';
                }
            }
            function createGroupsString(groups){
                switch (groups.length){
                    case 0:
                        return '';
                    case 1:
                        return 'Shared with ' + groups[0].name + " (group)";
                    case 2:
                        return 'Shared with ' + groups[0].name + ' and ' + groups[1].name + ' (groups)';
                    case 3:
                        return 'Shared with ' + _.pluck(groups.slice(0,2),'name').join(', ') + " and one other group";
                    default:
                        return 'Shared with ' + _.pluck(groups.slice(0,2),'name').join(', ') + ' and ' + (groups.length - 2) + ' other groups';
                }
            }

            $scope.share = function(){
                $scope.isWorking = true;
                var emails = _.map(_.pluck($scope.shareEmails.emails,'local.email'), function(email){return email.trim();});
                var groups = $scope.shareEmails.groups;
                var privileges = {share: $scope.canShare, schedule: $scope.canSchedule};
                if((emails && emails.length > 0) || (groups && groups.length > 0)) {
                    ShareService.share(item, emails, groups, privileges).then(function () {
                        NotificationService.notify("info-alert", {content: 'notifications.shareEmailSuccess'});
                    });
                }
                $uibModalInstance.close();
            };
            $scope.unshare = function(user, asset){
                NotificationService.confirm("Unshare member", "You are about to unshare " + asset.name + " with " + user.full_name, function(){
                    ShareService.unshare(user, asset).then(function () {
                        whoHasAccess(item);
                    });
                });
            };
            $scope.manage = function(group){
                $scope.$close();
                FarmService.openManageGroupPopup(group, function(){
                    whoHasAccess(item);
                });
            };
            $scope.unshareGroup = function(group, asset){
                NotificationService.confirm("Unshare from group", "You are about to unshare " + asset.name + " with " + group.name, function(){
                    ShareService.unshareGroup(group, asset).then(function () {
                        whoHasAccess(item);
                    });
                });
            };

            FarmService.getMembers({not: 'admin'}).then(function(members){
                $scope.shareEmails.available = members;
            });
            FarmService.getGroups().then(function(groups){
                $scope.shareEmails.availableGroups = groups;
            });

            $scope.cancel = function(){
                $scope.$close();
            };
        }]);
